import * as angular from "angular";
import {CustomFieldModel} from "../models/custom-field.model";
import {FieldType} from "../types/field.type";

export class PackageConfigurationDialogsService {

  public readonly fieldTypesList: FieldType[];
  public readonly fieldTypesMap: typeof FieldType = FieldType;

  /* @ngInject */
  constructor(private $mdDialog) {
    this.fieldTypesList = Object.values(FieldType);
  }

  createCustomField(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-custom-field-dialog.html').default,
      controller: function ($scope) {

        $scope.field = {
          name: undefined,
          type:  undefined,
          fieldOptions: []
        }

        $scope.fieldTypesList = self.fieldTypesList;
        $scope.fieldTypesMap = self.fieldTypesMap;

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onFieldTypeSelected = (type: FieldType) => {
          $scope.field.type = type;
          $scope.field.fieldOptions = (type === self.fieldTypesMap.DropdownMultiple || type === self.fieldTypesMap.DropdownSingle) ? [] : undefined;
        }

        $scope.onOptionsChange = (fieldOptions) => {
          $scope.field.fieldOptions = fieldOptions;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.field);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editCustomField(field, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/update-custom-field-dialog.html').default,
      controller: function ($scope) {

        $scope.field = angular.copy(field);

        $scope.fieldTypesList = self.fieldTypesList;
        $scope.fieldTypesMap = self.fieldTypesMap;

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onFieldTypeSelected = (type: FieldType) => {
          $scope.field.type = type;
          $scope.field.fieldOptions = (type === self.fieldTypesMap.DropdownMultiple || type === self.fieldTypesMap.DropdownSingle) ? [] : undefined;
        }

        $scope.onOptionsChange = (fieldOptions) => {
          $scope.field.fieldOptions = fieldOptions;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.field);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .service('packageConfigurationDialogsService', PackageConfigurationDialogsService);
